// extracted by mini-css-extract-plugin
export var crew = "style-module--crew--5175b";
export var img = "style-module--img--5a0b9";
export var imgLp = "style-module--img-lp--56ddf";
export var inner = "style-module--inner--1126e";
export var wrap = "style-module--wrap--45afb";